/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventfieldage2Inputs */

const en_eventfieldage2 = /** @type {(inputs: Eventfieldage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Age`)
};

const de_eventfieldage2 = /** @type {(inputs: Eventfieldage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alter`)
};

/**
* | output |
* | --- |
* | "Age" |
*
* @param {Eventfieldage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventfieldage2 = /** @type {((inputs?: Eventfieldage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventfieldage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventfieldage2(inputs)
	return de_eventfieldage2(inputs)
});
export { eventfieldage2 as "eventFieldAge" }